import React from "react"
import { Alert as ReactstrapAlert } from "reactstrap"

const Alert = props => {
  const { className = "success", color="", text } = props
  return (
    <ReactstrapAlert
      color={color}
      className={`gt-alert gt-alert-${color} ${className} fs-13`}
    >
      {text}
    </ReactstrapAlert>
  )
}
export default Alert
